import { render, staticRenderFns } from "./OrganizationEditModal.vue?vue&type=template&id=198ac896&scoped=true"
import script from "./OrganizationEditModal.vue?vue&type=script&lang=js"
export * from "./OrganizationEditModal.vue?vue&type=script&lang=js"
import style0 from "./OrganizationEditModal.vue?vue&type=style&index=0&id=198ac896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ac896",
  null
  
)

export default component.exports